import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    AfterViewInit,
    AfterViewChecked,
    AfterContentInit,
    Output,
    EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Project } from '../model/project';
import { Client } from '../model/client';
import { Questionnaire } from '../model/questionnaire';
import { ProjectNavigationState } from '../model/project-navigation-state';
import { ProjectService } from './project.service';

import {Terminal} from '../model/terminal';
import {CreateQuestionnaireComponent} from './createQuestionnaire/create-questionnaire.component';
import {ProjectNavbarComponent} from './projectNavBar/project-navbar.component';
import {QuestionnaireNodeComponent} from './questionnaireNode/questionnaire-node.component';
import {SharedRefreshService} from '../service/sharedRefreshService';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@Component({
    selector: 'project-component',
    template: `<loading *ngIf="_isLoading"></loading>
    <div class="row" *ngIf="!_isLoading">
      <div class="col">
        <div class="card-body">
          <project-navbar *ngIf="_project != null" (CreateQuestionnaire)="onCreateQuestionnaire()"  (QuestionnaireSelected)="onQuestionnaireSelected($event)" (TerminalSelected)="onTerminalSelected($event)" [navigation]="_navigationState"  [project]="_project"></project-navbar>
          <div *ngIf="_project != null" [ngSwitch]="_navigationState.selectedView">
            <ng-container *ngSwitchCase="'info'">
              <project-infos [project]="_project" [clients]="_clients" (breadCrumbLink)="onBreadCrumbSelected($event)"></project-infos>
              <!--<questionnaire-project [project]="_project"></questionnaire-project>-->
            </ng-container>
            <ng-container *ngSwitchCase="'questionnaires'">
              <div *ngIf="this._selectedQuestionnaire != null">
                <questionnaire-view [project]="_project"  [questionnaire]="_selectedQuestionnaire" (breadCrumbLink)="onBreadCrumbSelected($event)"></questionnaire-view>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'terminal'">
              <div *ngIf="this._selectedTerminal != null">
                <questionnaire-node [project]="this._project" [terminal]="this._selectedTerminal"  (DeviceSelected)="updateParentTerminal($event)"  (breadCrumbLink)="onBreadCrumbSelected($event)"></questionnaire-node>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="_project != null">
        <create-questionnaire-dialog #questionnaireDialog [project]="this._project" (NewQuestionnaire)="onNewQuestionnaire($event)"  [modalTitle]="_modalTitle" [placeholderText]="_placeHolderText" [terminal]="_terminal"></create-questionnaire-dialog>
      </div>
    </div>
    <generic-info-modal  [hide]="_hide" [statusCode]="_statusCode" [title]="_modalTitle" [text]="_modalText" (OkClick)="onOk()"></generic-info-modal>`,

})

export class ProjectComponent implements OnInit, OnDestroy,AfterViewInit,AfterViewChecked,AfterContentInit {
    private _subscription;
    private _isLoading = true;
    private _errorMessage;
    private _project: Project;
    private _clients: Client[];

    // Modal definition variables
    private _hide = true;
    private _modalText='';
    private _modalTitle: string;
    private _statusCode = 200;

    private _placeHolderText: string;
    private _terminal: boolean;
    private _navigationState: ProjectNavigationState;

    private _selectedQuestionnaire: Questionnaire;

    private _selectedTerminal: Terminal;

    private _calledOnce = false;

    private _questionnaire = [];

    private paramPID:any;

    @Output() refreshEvent:EventEmitter<any> = new EventEmitter();

    @ViewChild(CreateQuestionnaireComponent)  private childQuestionnaireDialog:CreateQuestionnaireComponent;
    @ViewChild(ProjectNavbarComponent)  private childProjectNavBar:ProjectNavbarComponent;
    @ViewChild(QuestionnaireNodeComponent) private childQuestionnaireNode:QuestionnaireNodeComponent;

    constructor(private _projectService: ProjectService, private _route: ActivatedRoute, router: Router, private _refreshService:SharedRefreshService) {
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this._project != null && this._navigationState != null) {
                    localStorage.setItem('nav_project_' + this._project.id, JSON.stringify(this._navigationState));
                }
            }
        });

        _refreshService.refreshEmitted.subscribe((val) => {
            if(val) {
                this.refreshProjects();
            }
        });

        this._subscription = this._route.params.subscribe(params => {

            this.paramPID = params['id'];

            if (this.paramPID ) {
                this.getProject(this.paramPID );
                this.getClient();
            }
        });
    }

    ngOnInit(): void {

    }

    private getProject(id:any) {
        this._projectService.getProject(id).subscribe(project => {

                const navigationStateJson = localStorage.getItem('nav_project_' + id);


                if (navigationStateJson != null ) {
                    this._navigationState = JSON.parse(navigationStateJson) as ProjectNavigationState;
                } else {
                    this._navigationState = new ProjectNavigationState();
                }

                this._navigationState.selectedView = 'info';  // whenever we navigate to a new project, we set on the info cover.

                localStorage.setItem('project_id', id);

                this._project = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(project,Project);

                console.log('this._navigationState.questionnaireId :'+this._navigationState.questionnaireId);

                console.log('this._project.questionnaires.length '+this._project.questionnaires.length);
                if (this._navigationState.questionnaireId !== 0) {
                    for (let i = 0; i < this._project.questionnaires.length; i++) {
                        const q:Questionnaire = this._project.questionnaires[i];
                        if (q.id === this._navigationState.questionnaireId) {
                            this._selectedQuestionnaire = q;
                            break;
                        }
                    }
                }
                // this.childProjectNavBar.updateTerminalList(this._project.questionnaires);
            },
            error => this._errorMessage = <any>error);
    }

    private getClient() {
        this._projectService.getClients()
            .then(clients => {
                    this._clients = clients;
                    this._isLoading = false;
                },
                error => this._errorMessage = <any>error);
    }

    ngAfterViewInit():void {
        // this.childProjectNavBar.updateTerminalList(this._project.questionnaires);
      console.log('ngAfterViewInit  has been called from project');
    }
    ngAfterViewChecked():void {
        if(this.childProjectNavBar!=null) {
             // this._questionnaire = this._project.questionnaires;
      console.log('This has been called from project');
            this._calledOnce = true;
        }

    }
    ngAfterContentInit():void {
        // this.childProjectNavBar.updateTerminalList(this._project.questionnaires);
    }

    onCreateQuestionnaire() {
        this.childQuestionnaireDialog.hideDialog();
        this._modalTitle = 'New Questionnaire';
        this._placeHolderText = 'Questionnaire Title';
        this._terminal = false;

    }

    /*onCreateTerminal() {
        this.childQuestionnaireDialog.generateQuestionnaireDropDownList();
        this.childQuestionnaireDialog.resetFields();
        this._modalTitle = 'New Terminal';
        this._placeHolderText = 'Terminal Questionnaire Title';
        this._terminal = true;
    }*/



    onNewQuestionnaire(val:number) {
      // this.childQuestionnaireDialog.hideDialog(); unnecessary

      console.log('project.component create');


      this._statusCode = val;
      this._modalTitle = 'Questionnaire';
      this._modalText ='Questionnaire has been created successfully.';
      this._hide = false;

      this.refreshProjects();

    }

    private refreshProjects() {
        this._projectService.getProject(this._project.id).subscribe(project => {
                // this.childProjectNavBar.updateNavbarContent(project.questionnaires);
          this._project = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(project,Project);
            },
            error => this._errorMessage = <any>error);

        // document.location.reload(true);

        // rajouter un refresh pour les questionnaires
        /*this._projectService.getProject(this._project.id).then(project => {
                this.childProjectNavBar.updateproject.questionnaires);
            },
            error => this._errorMessage = <any>error);*/
    }

    onQuestionnaireSelected(questionnaire:Questionnaire) {
        this._navigationState.selectedView = 'questionnaires';
        this._navigationState.questionnaireId = questionnaire.id;
        this._selectedQuestionnaire = questionnaire;
    }

    onTerminalSelected(terminal:Terminal) {
        this._navigationState.selectedView = 'terminal';
        this._navigationState.questionnaireId = terminal.id;
        if(typeof this.childQuestionnaireNode === 'undefined') {
          this._selectedTerminal = terminal;
        } else {
          this.childQuestionnaireNode.onSwitchTerminal(terminal);
        }




        /// this.childQuestionnaireNode.getAssociatedQuestionnaireName();

        /*if(terminal.type.length > 0)
		{
			if(terminal.type == "Android")
				this._selectedTerminalIndex = 1;
			else if(terminal.type == "Windows Desktop")
                this._selectedTerminalIndex = 2;
		}
		else {
            this._selectedTerminalIndex = 0;
		}*/
    }

    onBreadCrumbSelected(node:(Project|Questionnaire|Terminal)) {

      if(node instanceof Project) {
        this._navigationState.selectedView = 'info';
      } else if(node instanceof Questionnaire) {
        this.onQuestionnaireSelected(node);

      } else if(node instanceof Terminal) {
        this.onTerminalSelected(node);
      }
    }

    updateParentTerminal(terminalFromChild: Terminal) {
        this._selectedTerminal.type = terminalFromChild.type;
    }


    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

  onProjectSelected($event: Project | Questionnaire | Terminal) {
  }

    onOk() {
        this._hide = true;
    }

}
